<template>
  <div>
    <b-breadcrumb :items="itemsBread"></b-breadcrumb>
    <div class="m-3">
      <h3>Add New Page</h3>
      <AddElement category_id="5"></AddElement>
    </div>
  </div>
</template>

<script>
import AddElement from "@/components/ElementComponents/AddElement.vue";

export default {

  name: "AddNewPage",
  components: {
    AddElement,
  },
  data() {
    return {
      itemsBread: [
        {
          text: 'Home',
          to: '/dashboard'
        }, {
          text: 'Pages',
          to: '/pages/all'
        }, {
          text: 'Add Page',
          href: '#'
        }
      ],
    };
  },
};
</script>